<template>
  <div>
    <base-delete-dialog
      :show="willCancelRequest"
      :titleCaption="'Anfrage zurückziehen?'"
      :dialogText="'Willst du die Freundschaftsanfrage wirklich zurückziehen?'"
      :commitCaption="'Zurückziehen'"
      @commit="cancelRequest"
      @close="closeDialog"
    ></base-delete-dialog>
    <li class="list-element">
      <h4>
        {{ `${request.firstname} ${request.lastname} (${request.nickname})` }}
      </h4>
      <div class="cancel">
        <abbr title="Anfrage zurückziehen">
          <base-button class="flat" @click="askForCancel">
            <fa icon="times"
          /></base-button>
        </abbr>
      </div>
    </li>
  </div>
</template>

<script>
export default {
  data() {
    return {
      willCancelRequest: false,
    };
  },
  props: ["request"],
  emits: ["cancelRequest"],
  methods: {
    askForCancel() {
      this.willCancelRequest = true;
    },
    cancelRequest() {
      this.willCancelRequest = false;
      this.$emit("cancelRequest", this.request.userId);
    },
    closeDialog() {
      this.willCancelRequest = false;
    },
  },
};
</script>

<style scoped>
.list-element {
  padding: 0.1rem 1rem;
  display: grid;
  grid-template-columns: auto 2rem;
  grid-template-areas: "name cancel";
}
.flat {
  margin: 0;
}
.cancel {
  display: flex;
  align-items: center;
  justify-content: center;
}

.list-element:nth-child(odd) {
  background-color: rgba(211, 211, 211, 0.2);
}

.list-element:first-child {
  border-radius: 12px 12px 0 0;
}
.list-element:last-child {
  border-radius: 0 0 12px 12px;
}

/* .list-element:hover {
  background-color: #e2e1e1;
} */
</style>
